export default "__VITE_ASSET__CqkVnmub__"